module.exports = __webpack_public_path__ + "static/media/feature_not_available.png";